/* src/app/components/lead-details/health-assessment-list/health-assessment-list.component.css */
.health-assessment-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 4px 16px;
  align-items: center;
}
.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.meta-icon {
  color: #6b7280;
}
.meta-label {
  color: #6b7280;
  font-weight: 500;
}
.meta-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-weight: 600;
  line-height: 1.6;
}
.meta-badge--vendor {
  background: #e0e0e0;
  color: #01796F;
}
.meta-badge--progress {
  background: #e0e0e0;
  color: #01796F;
}
.meta-badge--expiring {
  background: #fef3c7;
  color: #92400e;
}
.meta-badge--expired {
  background: #fee2e2;
  color: #b91c1c;
}
/*# sourceMappingURL=health-assessment-list.component-ZGFI45EP.css.map */
